var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blade"},[_vm._t("divider"),_vm._v(" "),_vm._t("searchAndOther"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_vm._t("drawer"),_vm._v(" "),_vm._t("dialog"),_vm._v(" "),_vm._t("other")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125f2c81","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/blade/Blade.vue
// module id = null
// module chunks = 